import Swiper from 'swiper/bundle';

window.Swiper = Swiper;

export default Swiper;
